/* @flow */

import type { Storage } from "crustate";
import type { Client } from "@awardit/graphql-ast-client";
import type { AllProductsRequest, AllProductsResponse } from "@crossroads/shop-state/all-products";

import { ALL_PRODUCTS_REQUEST, ALL_PRODUCTS_RESPONSE } from "@crossroads/shop-state/all-products";
import { products as productsQuery } from "queries";
import { PAGE_SIZE, loadCampaignAwareProductList } from "./product-list-pagination";

const registerClient = (storage: Storage, client: Client<{}>) => {
  storage.addEffect({
    effect: async (msg: AllProductsRequest) => {
      const { products } = await loadCampaignAwareProductList({
        client,
        query: productsQuery,
        variables: {
          filter: msg.filters,
          sort: msg.sort,
          pageSize: PAGE_SIZE,
          page: msg.page !== null ? msg.page : 1,
        },
        productsPerRow: (msg: any).productsPerRow,
        productListPath: "products",
        pathname: "/all-products",
      });

      return ({
        tag: ALL_PRODUCTS_RESPONSE,
        data: products,
      }: AllProductsResponse);
    },
    subscribe: { [ALL_PRODUCTS_REQUEST]: true },
  });
};

export default registerClient;
